export const PROJECT_PROGRESS_TYPE_ENUM = {
  HOUR: 'hour',
  COST: 'cost'
};
